import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção dos demais relatórios de médico). */
export type EtiquetaProfissionalJob = ReportJob;
export type EtiquetaProfissionalJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do assistente Etiqueta Profissional (Médico). */
@Injectable({ providedIn: 'root' })
export class EtiquetaProfissionalJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'etiqueta-profissional-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.etiquetaProfissional;
}
